module.exports = __webpack_public_path__ + "static/media/folder-icon.b6e938d6.svg";